import { render, staticRenderFns } from "./OrganizerListItem.vue?vue&type=template&id=864d3636&scoped=true&"
import script from "./OrganizerListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizerListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerListItem.vue?vue&type=style&index=0&id=864d3636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d3636",
  null
  
)

export default component.exports